import _isPlainObject from "lodash.isplainobject";

export const answerTypes = {
  UNDEFINED: "UNDEFINED",
  PLAIN: "PLAIN",
  ARRAY: "ARRAY",
  OBJECT: "OBJECT",
  UNKNOWN: "UNKNOWN",
  FILE: "FILE"
};

export const isBase64Envoded = value =>
  typeof value === "string" && /^data:/.test(value);
export const extractNameFromBase64File = value => {
  const name = /name=(.*);/.exec(value);
  return name ? name[1] : null;
};

export const isPlain = value =>
  ["string", "number", "boolean"].includes(typeof value);

export const getType = value => {
  if (typeof value === "undefined") {
    return answerTypes.UNDEFINED;
  } else if (isPlain(value)) {
    // Assume file widget
    if (isBase64Envoded(value)) {
      return answerTypes.FILE;
    } else {
      return answerTypes.PLAIN;
    }
  } else if (Array.isArray(value)) {
    return answerTypes.ARRAY;
  } else if (_isPlainObject(value)) {
    return answerTypes.OBJECT;
  } else {
    return answerTypes.UNKNOWN;
  }
};
